import { render, staticRenderFns } from "./modalCalculoTempoJejum.vue?vue&type=template&id=f7e4cd28&"
import script from "./modalCalculoTempoJejum.vue?vue&type=script&lang=js&"
export * from "./modalCalculoTempoJejum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports